<template>
  <ActionModal
    v-model="modalDelete"
    title="Удалить заявку"
    :actions="buttonModalDelete"
  />

  <LoaderComponent v-if="isLoading" />

  <div :class="style.application" v-else>
    <SectionHeaderBlock
      title="Ваши заявки"
      subTitle="В вашем аккаунте пока нет заявок"
      :conditionSubTitle="!dataApplication.length"
      :class="style.sectionHeader"
    />

    <div :class="style.bodyApplication">
      <div :class="[style.row, style.headerRow]">
        <span>Дата</span>
        <span>Устройство</span>
        <span>Телефон</span>
        <span>Имя</span>
      </div>

      <div
        v-for="item in dataApplication"
        :key="item._id || item.DateTime"
        :class="[
          style.wrapperRow,
          (selectedApplication as Application)?._id === item._id
            ? style.active
            : null
        ]"
        @click="openDrawer(item)"
      >
        <div :class="style.row">
          <div :class="style.date">
            <span>
              {{ getDateParts(item)[0] }}
            </span>
            <span :class="style.time">
              {{ getDateParts(item)[1] }}
            </span>
          </div>

          <div :class="style.content">
            <img :src="getDeviceImg(item)" alt="" />
            {{ getDevice(item) }}
          </div>

          <div :class="style.content">
            {{ getValue(item, "Телефон") }}
          </div>

          <div :class="style.content">
            {{ getValue(item, "ФИО") || "-" }}
          </div>

          <div v-if="hasErrorIntegration(item)" :class="style.errorBlockRow">
            <span>Ошибка</span>
            <img :src="warningIcon" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <ApplicationDetailsDrawer
    v-if="selectedApplication"
    v-model="drawerOpen"
    :application="selectedApplication"
    :connectedIntegrations="connectedIntegrations"
    @delete="openDeleteModal"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ApplicationComponent.module.scss";
import {Application, ApplicationAK, strObj} from "./ApplicationType";
import monitorIcon from "$images/icons/tabs/Name=Monitor, Size=16, Tone=Default.svg";
import smartphoneIcon from "$images/icons/tabs/Name=Smartphone, Size=16, Tone=Default.svg";
import ApplicationDetailsDrawer from "@/page/onlineAppointment/application/ApplicationDetailsDrawer.vue";
import warningIcon from "$images/icons/badge/Name=Warning, Size=M.svg";
import ActionModal from "@/layout/nav/components/modal/modals/ActionModal/ActionModal.vue";
import SectionHeaderBlock from "@/elements/UI/section/SectionHeaderBlock/SectionHeaderBlock.vue";
import LoaderComponent from "@/elements/UI/overlay/Loader/LoaderComponent.vue";
import {API} from "@/api/generated";

export default defineComponent({
  name: "ApplicationComponent",
  components: {
    LoaderComponent,
    SectionHeaderBlock,
    ActionModal,
    ApplicationDetailsDrawer
  },
  data() {
    return {
      style,
      idDelete: "",
      selectedApplication: "" as Application | "",
      modalDelete: false,
      dataApplication: [] as Application[],
      connectedIntegrations: [] as string[],
      isLoading: true,
      __scrollLocked: false,
      __savedScrollY: 0,
      drawerOpen: false,
      monitorIcon,
      smartphoneIcon,
      warningIcon
    };
  },
  mounted() {
    this.getDataQuiz();
  },
  beforeUnmount() {
    this.unlockScroll();
  },
  methods: {
    resolveObjectStatus(value: Record<string, unknown> | undefined) {
      if (!value || typeof value !== "object") {
        return {
          text: "Нет данных"
        };
      }

      const values = Object.values(value);

      if (!values.length) {
        return {
          text: "Нет данных"
        };
      }

      const allOk = values.every((item) => item === "ok");
      const allNotOk = values.every((item) => item !== "ok");

      if (allOk) {
        return {
          text: "OK"
        };
      }

      if (allNotOk) {
        return {
          text: "Ошибка"
        };
      }

      return {
        text: "Частично"
      };
    },

    resolveAmoStatus(value: Record<string, unknown> | undefined) {
      if (!value || typeof value !== "object") {
        return {
          text: "Нет данных"
        };
      }

      const goodStatus = ["описание добавлено к заявке", "заявка создана"];

      const statusList = Object.values(value).filter(
        (item): item is string => typeof item === "string"
      );

      if (!statusList.length) {
        return {
          text: "Нет данных"
        };
      }

      const successCount = statusList.filter((status) =>
        goodStatus.includes(status)
      ).length;

      if (successCount === 0) {
        return {
          text: "Ошибка"
        };
      }

      if (successCount === statusList.length) {
        return {
          text: "OK"
        };
      }

      return {
        text: "Частично"
      };
    },

    resolveBitrixStatus(value: Record<string, unknown> | undefined) {
      if (!value || typeof value !== "object") {
        return {
          text: "Нет данных"
        };
      }

      const statusList = Object.values(value).filter(
        (item): item is string => typeof item === "string"
      );

      if (!statusList.length) {
        return {
          text: "Нет данных"
        };
      }

      const successCount = statusList.filter((status) =>
        status.toLowerCase().startsWith("лид создан")
      ).length;

      if (successCount === 0) {
        return {
          text: "Ошибка"
        };
      }

      if (successCount === statusList.length) {
        return {
          text: "OK"
        };
      }

      return {
        text: "Частично"
      };
    },

    resolveGoogleStatus(value: unknown) {
      const statusMessages = this.getGoogleStatusMessages(value);

      if (!statusMessages.length) {
        return {
          text: "Нет данных"
        };
      }

      if (this.isGoogleStatusWithoutIntegration(statusMessages)) {
        return {
          text: "Нет данных"
        };
      }

      const successTexts = [
        "Добавленны новые данные в таблицу",
        "Добавлены новые данные в таблицу"
      ];
      const isSuccess = statusMessages.some((message) =>
        successTexts.some((successText) => message.includes(successText))
      );

      return isSuccess ? {text: "OK"} : {text: "Ошибка"};
    },
    getGoogleStatusMessages(value: unknown): string[] {
      if (typeof value === "string") {
        return value.trim() ? [value] : [];
      }

      if (Array.isArray(value)) {
        return value
          .filter((item): item is string => typeof item === "string")
          .map((item) => item.trim())
          .filter(Boolean);
      }

      return [];
    },
    isGoogleStatusWithoutIntegration(statusMessages: string[]): boolean {
      const withoutIntegrationPatterns = [
        "ошибка получения данных из google sheets",
        "не подключ",
        "не настро",
        "не найд",
        "not connected",
        "not configured",
        "not found",
        "no google",
        "no spreadsheet",
        "no integration"
      ];

      return statusMessages.every((message) => {
        const normalizedMessage = message.toLowerCase();
        return withoutIntegrationPatterns.some((pattern) =>
          normalizedMessage.includes(pattern)
        );
      });
    },

    getIntegrationStatuses(application: ApplicationAK | "") {
      if (
        !application ||
        (typeof application === "string" && application === "")
      ) {
        return [];
      }

      const mail = this.resolveObjectStatus(application?.statusSend?.mail);
      const telegram = this.resolveObjectStatus(
        application?.statusSend?.telegramm
      );
      const max = this.resolveObjectStatus(application?.statusSend?.Max);
      const amo = this.resolveAmoStatus(application?.statusSend?.amo);
      const bitrix = this.resolveBitrixStatus(application?.statusSend?.bitrix);
      const google = this.resolveGoogleStatus(application?.statusSend?.google);

      return [
        {key: "mail", status: mail},
        {key: "telegram", status: telegram},
        {key: "max", status: max},
        {key: "amo", status: amo},
        {key: "bitrix", status: bitrix},
        {key: "google", status: google}
      ]
        .filter(({key}) => this.connectedIntegrations.includes(key))
        .map(({status}) => status);
    },

    async setConnectedIntegrations() {
      const integrations = await API.getIntegration();

      const integrationKeys: Array<[keyof typeof integrations, string]> = [
        ["email", "mail"],
        ["telegram", "telegram"],
        ["max", "max"],
        ["amoCrm", "amo"],
        ["bitrixCrm", "bitrix"],
        ["google", "google"]
      ];

      this.connectedIntegrations = integrationKeys
        .filter(([integrationKey]) => {
          const value = integrations[integrationKey];
          return Array.isArray(value) && value.length > 0;
        })
        .map(([, viewKey]) => viewKey);
    },

    hasErrorIntegration(application: ApplicationAK | "") {
      return this.getIntegrationStatuses(application).some(
        (integration) => integration.text === "Ошибка"
      );
    },
    openDrawer(item: Application | "") {
      this.selectedApplication = item;
      this.drawerOpen = true;
    },

    openDeleteModal(id: string) {
      this.idDelete = id;
      this.modalDelete = true;
    },

    getDateParts(item: ApplicationAK | "") {
      const value = this.getValue(item, "Дата");

      if (typeof value !== "string") {
        return ["", ""];
      }

      return value.split(", ");
    },

    getDevice(item: ApplicationAK | "") {
      const device = this.getValue(item, "Device") || "—";

      if (device === "Компьютер") {
        return "ПК";
      } else if (device === "Телефон") {
        return "МБ";
      }

      return this.getValue(item, "Device") || "—";
    },

    getDeviceImg(item: ApplicationAK | "") {
      const device = this.getDevice(item);

      if (device === "ПК") {
        return this.monitorIcon;
      } else if (device === "МБ") {
        return this.smartphoneIcon;
      }

      return "";
    },

    lockScroll() {
      if (this.__scrollLocked) return;

      this.__savedScrollY = window.scrollY || window.pageYOffset || 0;

      const body = document.body;
      const html = document.documentElement;

      body.dataset.scrollY = String(this.__savedScrollY);
      body.style.position = "fixed";
      body.style.top = `-${this.__savedScrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";

      this.__scrollLocked = true;
    },

    unlockScroll() {
      if (!this.__scrollLocked) return;

      const body = document.body;
      const html = document.documentElement;
      const saved = Number(body.dataset.scrollY || this.__savedScrollY || 0);

      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.overflow = "";
      html.style.overflow = "";

      window.scrollTo(0, saved);

      delete body.dataset.scrollY;
      this.__scrollLocked = false;
    },

    async getDataQuiz() {
      this.isLoading = true;

      try {
        const timeZone = -(new Date().getTimezoneOffset() / 60);
        await this.setConnectedIntegrations();
        let quizData;
        try {
          const quizDataAPI = await API.getQuizData();
          quizData = quizDataAPI.map((d) => {
            if (d.createdAt) {
              const newDate = new Date(d.createdAt);
              newDate.setHours(newDate.getHours() + Number(timeZone));

              const newDateStr = newDate.toISOString();
              const [date, time] = newDateStr.split("T");
              const [year, month, day] = date.split("-");
              const DateTime = `${day}.${month}.${year} ${time.substr(0, 5)}`;

              return {
                ...d,
                ...d.data,
                DateTime
              };
            }
            return {
              ...d,
              ...d.data
            };
          });
        } catch (e) {
          throw e;
        }

        const ticketData = await API.getTicketsAuth();

        if (quizData.length !== 0 && quizData[0].quizId) {
          await this.$quizStore.fetchQuiz([quizData[0].quizId, true]);
        }

        type DataApplicationItem =
          (typeof quizData)[number] | (typeof ticketData)[number];

        function sort(a: DataApplicationItem, b: DataApplicationItem) {
          function getTime(obj: DataApplicationItem) {
            if ("DateTime" in obj && obj?.DateTime) {
              const [date, time] = obj.DateTime.split(" ");

              if (!date.includes(".") || time.length !== 5) {
                return -1;
              }

              const [day, month, year] = date.split(".");
              return new Date(`${year}-${month}-${day}T${time}`).getTime();
            } else if ("createdAt" in obj && obj?.createdAt) {
              return new Date(obj.createdAt).getTime();
            }

            return 0;
          }

          if (getTime(a) < getTime(b)) return 1;
          if (getTime(a) > getTime(b)) return -1;
          return 0;
        }

        this.dataApplication = [...quizData, ...ticketData].sort(
          sort
        ) as Application[];
      } catch (error) {
        console.error("Ошибка при получении заявок:", error);
      } finally {
        this.isLoading = false;
      }
    },

    getValue(
      application: ApplicationAK | "",
      key: string
    ): string | strObj | undefined {
      if (application === "") {
        return "";
      }

      if (key === "Время записи" && application["PlanStart"]) {
        return this.getNormalDate(application["PlanStart"]);
      }

      if (application[key]) {
        return application[key] as strObj | string;
      }

      switch (key) {
        case "Телефон":
          return application["ClientPhone"];
        case "ФИО":
          return (
            application["ClientFullName"] ?? (application["Имя"] as string)
          );
        case "Дата":
          return this.getNormalDate(
            application["DateTime"] ?? application["createdAt"]
          );
        case "Комментарий":
          return application["comment"] ?? (application["Comment"] as string);
        case "statusMail":
          return application["statusSend"]?.["mail"];
        case "statusTg":
          return application["statusSend"]?.["telegramm"];
        case "statusAmo":
          return application["statusSend"]?.["amo"];
        case "statusGoogle":
          return application["statusSend"]?.["google"];
      }

      return application[this.getTranslationEnKey(key)] as strObj | string;
    },

    async deleteApplication(): Promise<void> {
      if (!this.idDelete) {
        return;
      }

      const deletedId = this.idDelete;

      try {
        await API.deleteTicketAndQuiz({
          query: {
            id: deletedId
          }
        });

        this.dataApplication = this.dataApplication.filter(
          (item) => item._id !== deletedId
        );

        if (
          this.selectedApplication &&
          typeof this.selectedApplication === "object" &&
          this.selectedApplication._id === deletedId
        ) {
          this.selectedApplication = "";
        }

        this.drawerOpen = false;
        this.modalDelete = false;
        this.idDelete = "";
      } catch (error) {
        console.error("Ошибка при удалении заявки:", error);
      }
    },

    cancelDeleteApplication() {
      this.modalDelete = false;
      this.idDelete = "";
    },

    getNormalDate(date: string) {
      if (!date) return "";

      if (date.includes("T")) {
        const dateISO = date.split("T");
        const timeArr = dateISO[1].split(":");
        const dateArr = dateISO[0].split("-");
        return `${dateArr[2]}.${dateArr[1]}.${dateArr[0]}, ${timeArr[0]}:${timeArr[1]}`;
      }

      const dateAndTime = date.split(" ");
      const dateSplit = dateAndTime[0].split(".");
      return `${dateSplit[0]}.${dateSplit[1]}.${dateSplit[2]}, ${dateAndTime[1]}`;
    },

    getTranslationEnKey(key: string) {
      switch (key) {
        case "Время записи":
          return "PlanStart";
        case "Специалист":
          return "DoctorName";
        case "Дата рождения":
          return "birthdate";
        case "Услуга":
          return "DoctorService";
        case "Device":
          return "deviceType";
      }

      return key;
    }
  },

  computed: {
    anyModalOpen() {
      return this.drawerOpen || this.modalDelete;
    },
    buttonModalDelete(): ListActionItem[] {
      return [
        {
          text: "Удалить",
          handler: this.deleteApplication
        },
        {
          text: "Отмена",
          handler: this.cancelDeleteApplication
        }
      ];
    }
  },

  watch: {
    drawerOpen(data: boolean) {
      if (data === false) {
        this.selectedApplication = "";
      }
    },

    idDelete() {
      this.modalDelete = this.idDelete !== "";
    },

    modalDelete(isOpen: boolean) {
      if (!isOpen) {
        this.idDelete = "";
      }
    },

    anyModalOpen(isOpen: boolean) {
      if (isOpen) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    }
  }
});
</script>
